import _ from 'lodash';
/**
 *
 * @param theme required to get the breakpoints
 * @param screenWidth required to select the active breakpoint
 * @param responsiveValue this value will be resolved
 */
export default function resolveResponsiveValue(theme, screenWidth, responsiveValue) {
    var _a;
    if (_.isArray(responsiveValue)) {
        // ToDo: use the screenWidth here to select the active breakpoint value
        var currentValue = screenWidth !== ((_a = theme.designGrid.breakpoints[0]) === null || _a === void 0 ? void 0 : _a.min) ? responsiveValue[0] : undefined;
        if (isCustomBreakpoint(currentValue)) {
            return currentValue.value;
        }
        return currentValue;
    }
    return responsiveValue;
}
function isCustomBreakpoint(obj) {
    // T should be a number, string or boolean, but not an object
    return typeof obj === 'object';
}
//# sourceMappingURL=ResponsiveValueResolver.js.map